import * as React from 'react'
import type { SVGProps } from 'react'
function SvgMsKlimadashboardIconsNaviMehrDetailsPlus(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      data-name="Ebene 1"
      id="MS_Klimadashboard_Icons_Navi_mehr-Details_plus_svg__Ebene_1"
      viewBox="0 0 24.08 24.08"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <style>
          {
            '.MS_Klimadashboard_Icons_Navi_mehr-Details_plus_svg__cls-1{fill:#005096}'
          }
        </style>
      </defs>
      <path
        className="MS_Klimadashboard_Icons_Navi_mehr-Details_plus_svg__cls-1"
        d="M16.14 11.09h-2.99v-3.3c0-.55-.45-1-1-1s-1 .45-1 1v3.3H8.16c-.55 0-1 .45-1 1s.45 1 1 1h2.99v3.3c0 .55.45 1 1 1s1-.45 1-1v-3.3h2.99c.55 0 1-.45 1-1s-.45-1-1-1Z"
      />
      <path
        className="MS_Klimadashboard_Icons_Navi_mehr-Details_plus_svg__cls-1"
        d="M12.04 0C5.39 0 0 5.39 0 12.04s5.39 12.04 12.04 12.04 12.04-5.39 12.04-12.04S18.69 0 12.04 0Zm0 22.07c-5.54 0-10.03-4.49-10.03-10.03S6.5 2.01 12.04 2.01c5.54 0 10.03 4.49 10.03 10.03 0 5.54-4.49 10.03-10.03 10.03Z"
      />
    </svg>
  )
}
export default SvgMsKlimadashboardIconsNaviMehrDetailsPlus
